<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des codes postaux</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="6" class="borded-right">
              <b-form-group label='Code postal à rechercher' label-for='cpToSearch'>
                <b-row class="mb-1">
                  <b-col sm="7">
                    <b-form-input id='cpToSearch' type='text' v-model="cpToSearch" :class="{hasError: errors.cpToSearch !== ''}"></b-form-input>
                  </b-col>
                  <b-col sm="5">
                    <b-button size="md" variant="success" @click.prevent="search()"><i class="fa fa-loupe"></i> Rechercher</b-button>
                  </b-col>
                </b-row>
                <span class='field-error'>{{ errors.cpToSearch }}</span>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-list-group class="align-middle" v-if="searchDone && cpFind === ''">
                <b-list-group-item>Le code postal n'a pas été trouvé. Voulez-vous le créer ? <b-badge @click="startCreation()" class="clickable" variant="success">Oui</b-badge></b-list-group-item>
              </b-list-group>
              <b-list-group class="align-middle" v-if="cpFind !== ''">
                <b-list-group-item>{{ cpFind.code_postal }} rattaché à la délégation de {{ getDelegation(cpFind.delegation_id) }}<i v-if="canManageCp()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteCp(cpFind.id)"></i><i v-if="canManageCp()" class="icon fa fa-pencil float-right clickable" @click="edit(cpFind)"></i></b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-body class="small-padding" v-if="addEditCp">
          <hr>
          <b-row class="">
            <b-col md="6">
              <b-form-group
                label='Code Postal'
                label-for='cpToCreate'
              >
                <b-form-input id='cpToCreate' type='text' v-model="cpToCreate" :class="{hasError: errors.cpToCreate !== ''}" disabled></b-form-input>
                <span class='field-error'>{{ errors.cpToCreate }}</span>
              </b-form-group>
              <b-form-select v-model="selectedDelegation" :options="allDelegations" :class="{hasError: errors.selectedDelegation !== ''}">
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Merci de choisir une délégation --</b-form-select-option>
                </template>
              </b-form-select>
              <span class='field-error'>{{ errors.selectedDelegation }}</span>
              <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="mr-2 mt-1"><i class="fa fa-save"></i> Créer</b-button>
              <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="mr-2 mt-1"><i class="fa fa-save"></i> Modifier</b-button>
            </b-col>
            <b-col md="6">
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import itemList from '@/components/SortListItem'

export default {
  components: {
    SlickList,
    itemList
  },
  data() {
    return {
      addEditCp: false,
      cpId: '',
      cpToCreate: '',
      cpToSearch: '',
      cpSearched: '',
      cpFind: '',
      allDelegations: [],
      selectedDelegation: null,
      searchDone: false,
      action: 'create',
      errors: {
        cpToCreate: '',
        cpToSearch: '',
        selectedDelegation: '',
      }
    }
  },
  mounted() {
    this.getDelegations()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getDelegations() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/delegation/all")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          // this.allDelegations = response.data.data
          for(let delegation of response.data.data) {
            this.allDelegations.push({value: delegation.id, text: delegation.nom})
          }
          // console.log(this.allDelegations)
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    search() {
      let self = this
      let dataPost = {
        'cp': this.cpToSearch,
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/codePostal/search', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          this.clearData()
          this.searchDone = true
          this.cpSearched = this.cpToSearch
          if (response.data.cp) {
            this.cpFind = response.data.cp
          }
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors de la création du segment, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    getDelegation(delegationId) {
      let name = ''
      for(let delegation of this.allDelegations) {
        if (delegation.value === delegationId) { name = delegation.text }
      }

      return name
    },
    startCreation() {
      this.addEditCp = true
      this.cpToCreate = this.cpSearched
    },
    create() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          'cp': this.cpToCreate,
          'delegation_id': this.selectedDelegation,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/codePostal/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearData()
            this.cpToSearch = response.data.cp.code_postal
            if (response.data.cp) {
              this.cpFind = response.data.cp
            }
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création du code postal, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          'cp': this.cpToCreate,
          'delegation_id': this.selectedDelegation,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/codePostal/modify/'+this.cpId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearData()
            this.cpToSearch = response.data.cp.code_postal
            if (response.data.cp) {
              this.cpFind = response.data.cp
            }
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du code postal, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteCp(cpId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer ce code postal ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/codePostal/delete/"+cpId).then(response => {
                this.$store.commit("IS_LOADING", false)
                this.clearData()
                this.cpToSearch = ''
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false)
                  // console.log(error.response.status)
                  let errorText = "Une erreur est survenue, lors de la suppression du code postal. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    canManageCp() {
      return hasRule(rules.MANAGE_TABLE_CODE_POSTAL)
    },
    edit(cp) {
      this.cpToCreate = cp.code_postal
      this.selectedDelegation = cp.delegation_id
      this.cpId = cp.id
      this.action = 'modify'
      this.addEditCp = true
    },
    validate() {
      let valid = true

      if (this.cpToCreate === '') {
        this.errors.cpToCreate = 'Le code postal est obligatoire'
        valid = false;
      }

      if (this.selectedDelegation === null) {
        this.errors.selectedDelegation = 'Vous devez choisir une délégation à laquelle rattaché le code postal'
        valid = false;
      }

      return valid
    },
    clearData() {
      this.clearError()
      this.cpId = ''
      this.cpToCreate = ''
      this.cpFind = ''
      this.selectedDelegation = null
      this.searchDone = false
      this.addEditCp = false
      this.action = 'create'
    },
    clearError() {
      this.errors.libelle = ''
      this.errors.libelleTechnique = ''
    },
  }
}
</script>
<style type="text/css">
  .borded-right {
    border-right: 1px solid #EFEFEF;
  }
</style>